module.exports = __webpack_public_path__ + "img/carshina22_08.9bb60463.jpg";